// extracted by mini-css-extract-plugin
export default {"progressInfo":"Progress_progressInfo__GFO7i"};